module.exports = __webpack_public_path__ + "img/maas_bg2.95689525.png";